// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React from 'react';

import * as Styles from './CustomTag.styles';

function CustomTag(props) {
  return <Styles.StyledTag {...props} />;
}

export default CustomTag;
